import React from "react";
import Header from "../components/header";
import Footer from "../components/Footer";
import "./../main.css";

function TermsAndConditions() {
    return (
        <>
            <Header />

            <section class="author-bg" style={{ padding: '16px', marginTop: '56px' }}>
                <div class="author-inner" style={{ textAlign: 'center' }}>
                    <h2 class="author-name" style={{ margin: '15px' }}>Terms & Conditions</h2>
                </div>
            </section>
            <section className="hero privacy-policy" style={{ textAlign: 'left' }}>
                <div className="privacy-container">
                    <p>
                        Welcome to DeSantis1776.com, owned and operated by Free State Solution LLC.
                        By accessing this Website or purchasing products from us, you agree to be bound by these Terms and Conditions.
                        If you do not agree to these Terms, please do not use this Website.
                    </p>

                    <h2>1. Limited Edition Release</h2>
                    <p>This publication is a limited-edition release.</p>
                    <p>A maximum of 1776 copies of the book will be offered for sale.</p>
                    <p>
                        Each copy of the book will be individually hand-signed by Ron DeSantis and individually numbered in sequential order from 1 through 1776.
                    </p>
                    <p>
                        Only 1776 numbered copies will exist as part of this limited edition, and no additional numbered copies will be issued.
                    </p>
                    <p>
                        The specific numbered copy assigned to a purchaser will be determined solely by the Company and cannot be selected, reserved, or guaranteed.
                    </p>
                    <p>
                        The Company may maintain a limited number of signed reserve copies for replacement purposes.
                        Such reserve copies, if issued, will not be part of the numbered edition and may be marked or otherwise distinguished from the numbered edition.
                    </p>
                    <p>
                        Reserve copies are maintained solely for replacement purposes and will not be offered for sale.
                    </p>
                    <p>
                        Once all 1,776 copies have been sold, this edition will be considered sold out.
                    </p>
                    <p>
                        No additional copies of this book will be printed or produced beyond the original 1776 numbered copies.
                    </p>

                    <h2>2. Product Availability</h2>
                    <p>All products are offered subject to availability.</p>
                    <p>
                        The Company does not impose purchase quantity limits. A customer may purchase any quantity of books that remains available at the time of purchase.
                    </p>
                    <p>
                        The Company reserves the right to refuse or cancel any order at its sole discretion, including but not limited to suspected fraud, pricing errors, inventory discrepancies, or technical issues.
                    </p>
                    <p>
                        If an order is canceled after payment has been received, a full refund will be issued.
                    </p>

                    <h2>3. Pricing</h2>
                    <p>All prices are listed in U.S. Dollars (USD).</p>
                    <p>
                        Applicable taxes and shipping charges will be calculated and displayed during checkout.
                        Prices are subject to change without notice until an order has been successfully completed.
                    </p>

                    <h2>4. Payment</h2>
                    <p>Payments are processed securely through third-party payment processors.</p>
                    <p>The Company does not store complete credit card information.</p>
                    <p>
                        Orders are not considered accepted until payment has been successfully authorized and processed.
                    </p>
                    <p>
                        If a payment processor declines a transaction, the Company shall have no obligation to fulfill the order.
                    </p>

                    <h2>5. Pre-Orders</h2>
                    <p>This book is offered for purchase on a pre-order basis.</p>
                    <p>
                        By placing a pre-order, customers acknowledge and agree that the book may not ship immediately following purchase.
                    </p>
                    <p>
                        The Company currently anticipates shipping orders on or before July 4, 2026.
                        Estimated shipping dates are provided in good faith but are not guaranteed and may change due to production schedules, fulfillment requirements, shipping delays, or other circumstances beyond the Company’s reasonable control.
                    </p>
                    <p>
                        If significant delays occur, the Company will make reasonable efforts to notify customers.
                        If the Company is unable to fulfill an order, the customer will receive a full refund of the purchase price.
                    </p>

                    <h2>6. Order Cancellations and Refunds</h2>
                    <p>Once an order has shipped, cancellations are not permitted.</p>
                    <p>
                        Because this is a limited-edition signed publication, all sales are considered final after shipment except as expressly stated herein or as required by applicable law.
                    </p>
                    <p>Refunds or replacements may be provided only if:</p>
                    <ul>
                        <li>The product arrives damaged.</li>
                    </ul>
                    <p>
                        Requests for refunds must be submitted within fourteen (14) days of delivery and may require photographs or other documentation.
                    </p>
                    <p>
                        The Company reserves the right to determine, in its reasonable discretion, whether a refund, replacement or other remedy is appropriate.
                    </p>
                    <p>
                        Replacement copies, if issued, may not bear the same edition number as the original book and may contain markings identifying them as replacement copies.
                    </p>
                    <p>
                        The Company is not obligated to replace books that are lost, stolen, damaged after delivery, or damaged as a result of misuse, neglect or improper handling.
                    </p>

                    <h2>7. Shipping</h2>
                    <p>
                        The Company will make reasonable efforts to ship orders on or before the anticipated shipping date.
                        Shipping estimates are provided for convenience only and are not guaranteed.
                    </p>
                    <p>
                        The Company is not responsible for delays caused by circumstances beyond the Company’s reasonable control.
                    </p>
                    <p>
                        Tracking information will be provided when available.
                    </p>

                    <h2>8. Lost or Stolen Packages</h2>
                    <p>
                        The Company is not responsible for packages that are marked as delivered by the shipping carrier but are subsequently lost or stolen.
                    </p>
                    <p>
                        Customers are encouraged to monitor tracking information and arrange for secure delivery locations.
                    </p>
                    <p>
                        Claims relating to shipping issues should be submitted promptly so that the Company may assist where possible.
                    </p>

                    <h2>9. Product Descriptions</h2>
                    <p>
                        The Company strives to accurately describe and display all products offered on the Website.
                        However, minor variations in appearance, packaging, printing, coloration, or presentation may occur and shall not constitute defects.
                        Images displayed on the Website are for illustrative purposes and may differ slightly from the final product.
                    </p>

                    <h2>10. Intellectual Property</h2>
                    <p>
                        All content appearing on this Website, including but not limited to text, photographs, graphics, logos, videos, designs, trademarks, and other materials,
                        is the property of the Company or its licensors and is protected by applicable copyright, trademark, and intellectual property laws.
                    </p>
                    <p>
                        No content may be copied, reproduced, distributed, modified, or used without prior written permission from the Company.
                    </p>

                    <h2>11. Limitation of Liability</h2>
                    <p>
                        To the fullest extent permitted by law, the Company’s liability for any claim arising out of or related to the purchase or use of any product shall not exceed the amount paid by the customer for that product.
                    </p>
                    <p>
                        The Company shall not be liable for any indirect, incidental, consequential, special, or punitive damages, including but not limited to loss of profits, loss of data, or loss of business opportunities.
                    </p>

                    <h2>12. Disclaimer of Warranties</h2>
                    <p>
                        Except as expressly stated herein, all products and services are provided “as is” and “as available.”
                    </p>
                    <p>
                        The Company makes no warranties, express or implied, including warranties of merchantability, fitness for a particular purpose, or non-infringement.
                    </p>

                <h2>13. Governing Law</h2>
                    <p>
                        These Terms and Conditions shall be governed by and construed in accordance with the laws of the State of Florida without regard to its conflict of law provisions.
                    </p>

                    <h2>14. Changes to These Terms</h2>
                    <p>
                        The Company reserves the right to modify these Terms and Conditions at any time.
                        Changes become effective immediately upon posting to this Website.
                        Customers are encouraged to review these Terms periodically.
                    </p>

                    <h2>15. Contact Information</h2>
                    <p>Questions regarding these Terms and Conditions may be directed to:</p>

                    <p>
                        <strong>Free State Solution LLC (DeSantis 1776)</strong><br />
                        Email: <a href="mailto:Orders@DeSantis1776.com" className="linkto">
                            Orders@DeSantis1776.com
                        </a>
                    </p>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default TermsAndConditions;